var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8725602ClipboardNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 28,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_57_2369",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_57_2369",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAwpJREFUaENj/P//P8NQBoyjHhjg6BsBMbCSkagwblzDwCErzDDFUJEhRF6EgVeIh4EJWeO7Lwz/Hrxm+Hz+AcPqJ28ZcutDGH4QZXA4/jxKOAaI8EDLOgZlfxOGi7pyDNzEOOryI4YvG88w6NUEMdwnqJ7WHgCGPFuwOcM7HVniHA9zMMgT604xCAJj4g9eT9DaA/P2M8xJcmRIJhiSWBQA9c4C6k2niweAIc2nJM4w30CewQ1I83CzY7f22C2GV4euM3hV+DOcRVbRsZHB1F6TYaulGoMoNp1ffzIw3HvJ8OXiQ4Ydd18yJANj5hNYHTViAGi5caApw2F1KQZOQiENVGsGdPxpbOraNzCYVwYwnCBkxo1nDN83nGawBQcCpR5oDGXki7BieEGM46EOI1RsEVX1gzyx8hiDRP3q/5CYwAEIlkKLcxjXxtoyBBEKNSR5qngAZN7iwwyrY6f8D6PIA5e7Gb8gF49Y0jhRIYovEEFy2PLIJWBJpVf6n5ciD3xdxPgPmGHhoYoljVPFAyBHoueRLz8Y/vPE/0epENE9QzAJMaxkRHcgShJ5/oHhj6QAAzMJSQyu9Nl7hr9SggwsaHpR7Qv/jzdJUuyBabsYagPNGOpJ9QTI8etPMzRkuzG0DKgHyAl5AnroGwOjHsAMgdEYQA0TAqUQMBM3BJkx1EiQWBIBS6+/608xNGa5MTQPaCYe8sXokPfAaD0wWgoRGpkjUAqNVmQDnYSIrQfwlPvoXqBvTUxKMYqj+TzqAfz5kHBTgqj+AJ72/8DGwGgpNNCl0GgMjMbAcG9KEDGwRbVsQJOBLfShxeO3GF4fvM7gjWsEmlzfgBzvqM2wxUKVQQRmBlWGFpfkMK6OsWUIIddhlOijyuAuaHg9HDi8rkHE3AAljkXXCx1eFwMOr3+haHAXODYKGjk2DgBOcNDLE1Sd4AB5AASAU0w8wKmlefryDJ7K4gzcyCPW1Ah54BTTf+DUEniKCTjVlAScYoKEPKUzNNRwHC3NIDw6TUvbqWD2qAeoEIgUGQEALIQPv0UtSFsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8725602ClipboardNotesIcon);
export default __webpack_public_path__ + "static/media/8725602_clipboard_notes_icon.bb707ef9ee950e189541bb3648fb7422.svg";
export { ForwardRef as ReactComponent };